module.exports = __webpack_public_path__ + "img/customer1_4.0403c076.png";